import { FC } from "react";
import NavigationBar2 from "./skins/skin-2/navigation-bar-2";

const NavigationBar: FC = () => {
  return <NavigationBar2 />;
};

export default NavigationBar;
